import { handleActions } from 'redux-actions';
import { Map } from 'immutable';

import actions from '../../actions';

//REDUCERS
const { reservationRequest } = actions.customer;
export default handleActions(
  {
    [reservationRequest.set.toString()]: (reservationRequest, { payload }) => {
      return reservationRequest.merge(payload);
    },
    [reservationRequest.initialize.toString()]: (reservationRequest, { payload }) => {
      return payload;
    },
    [reservationRequest.setBlock.toString()]: (reservationRequest, { payload }) => {
      return reservationRequest.set('blocks', payload);
    },
    [reservationRequest.setBlocks.toString()]: (reservationRequest, { payload }) => {
      return reservationRequest.set('blocks', payload);
    },
    [reservationRequest.addService.toString()]: (reservationRequest, { payload }) => {
      return reservationRequest.set('blocks', payload);
    },
    [reservationRequest.addServiceByTime.toString()]: (reservationRequest, { payload }) => {
      return reservationRequest.set('blocks', payload);
    },
    [reservationRequest.setServiceQuantity.toString()]: (reservationRequest, { payload }) => {
      return reservationRequest.set('blocks', payload);
    },
    [reservationRequest.removeServiceByTime.toString()]: (reservationRequest, { payload }) => {
      return reservationRequest.set('blocks', payload);
    },
    [reservationRequest.removeService.toString()]: (reservationRequest, { payload }) => {
      return reservationRequest.set('blocks', payload);
    },
    [reservationRequest.addRoomPreferences.toString()]: (reservationRequest, { payload }) => {
      return payload;
    }
  },
  Map()
);
